import { render, staticRenderFns } from "./NotesForm.vue?vue&type=template&id=d66a920e&scoped=true&"
import script from "./NotesForm.vue?vue&type=script&lang=js&"
export * from "./NotesForm.vue?vue&type=script&lang=js&"
import style0 from "./NotesForm.vue?vue&type=style&index=0&id=d66a920e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66a920e",
  null
  
)

export default component.exports